import type { ComputedRef } from 'vue'
import { computed } from 'vue'
import { useStore } from 'vuex'

import type { RemarkTag } from '@app/shared/types/sf-data'

interface TalkingPointGetters {
  talkingPointTag: RemarkTag | undefined
}

interface UseTalkingPointTagReturn {
  talkingPointTag: ComputedRef<RemarkTag | undefined>
  talkingPointTagIds: ComputedRef<number[]>
}

export const useTalkingPointTag = (): UseTalkingPointTagReturn => {
  const store = useStore()

  const talkingPointTag = computed(
    () => (store.getters as TalkingPointGetters).talkingPointTag
  )
  const talkingPointTagIds = computed(() =>
    talkingPointTag.value ? [talkingPointTag.value.id] : []
  )

  return { talkingPointTag, talkingPointTagIds }
}
